// frontend/src/components/ViewTerminalModal.tsx
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Terminal } from "./types"; // Adjust import path as needed

interface ViewTerminalModalProps {
    terminal: Terminal;
    onClose: () => void;
}

export default function ViewTerminalModal({ terminal, onClose }: ViewTerminalModalProps): JSX.Element {
    return (
        <Dialog open onOpenChange={onClose}>
            <DialogContent className="max-w-md">
                <div className="mb-4">
                    <DialogTitle className="text-lg font-bold">Terminal Details</DialogTitle>
                </div>
                <div className="space-y-2">
                    <p><strong>Terminal ID:</strong> {terminal.terminalId}</p>
                    <p><strong>Terminal Name:</strong> {terminal.terminalName}</p>
                    <p><strong>Serial Number:</strong> {terminal.serialNumber}</p>
                    <p><strong>Terminal Model:</strong> {terminal.terminalModel}</p>
                    <p><strong>Merchant ID:</strong> {terminal.merchantId}</p>
                    <p><strong>Terminal Address:</strong> {terminal.terminalAddress || "N/A"}</p>
                    <p><strong>Approval Status:</strong> {terminal.approvalStatus}</p>
                    <p><strong>Status:</strong> {terminal.isEnabled ? "Active" : "Inactive"}</p>
                    <p><strong>Is Direct:</strong> {terminal.isDirect ? "Yes" : "No"}</p>
                    <p><strong>Customer Type:</strong> {terminal.customerType}</p>
                    <p><strong>Transaction Limit:</strong> {terminal.transactionLimit}</p>
                    <p><strong>Maximum Amount:</strong> ₦{terminal.maximumAmount.toLocaleString()}</p>
                    <p><strong>Allow Balance:</strong> {terminal.allowBalance ? "Yes" : "No"}</p>
                    <p><strong>Print Receipt:</strong> {terminal.printReciept ? "Yes" : "No"}</p>
                    <p><strong>View Balance:</strong> {terminal.viewBalance ? "Yes" : "No"}</p>
                    <p><strong>E-Journal:</strong> {terminal.eJournal ? "Yes" : "No"}</p>
                    <p><strong>Created At:</strong> {new Date(terminal.createdAt).toLocaleString()}</p>
                    <p><strong>Mapped to Merchant Serial:</strong> {terminal.isMappedToMerchantSerial ? "Yes" : "No"}</p>
                </div>
            </DialogContent>
        </Dialog>
    );
}